import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#807560",
      d: "M7 9.917a.56.56 0 0 0 .416-.168.56.56 0 0 0 .167-.416.56.56 0 0 0-.167-.415A.56.56 0 0 0 7 8.75a.56.56 0 0 0-.416.168.56.56 0 0 0-.167.415q0 .248.167.416T7 9.917m-.583-2.334h1.166v-3.5H6.417zM7 12.833a5.7 5.7 0 0 1-2.275-.459 5.9 5.9 0 0 1-1.852-1.247 5.9 5.9 0 0 1-1.247-1.852A5.7 5.7 0 0 1 1.166 7q0-1.21.46-2.275a5.9 5.9 0 0 1 1.247-1.852 5.9 5.9 0 0 1 1.852-1.247A5.7 5.7 0 0 1 7 1.166a5.7 5.7 0 0 1 2.275.46q1.065.46 1.852 1.247a5.9 5.9 0 0 1 1.247 1.852q.46 1.065.46 2.275a5.7 5.7 0 0 1-.46 2.275 5.9 5.9 0 0 1-1.247 1.852 5.9 5.9 0 0 1-1.852 1.247 5.7 5.7 0 0 1-2.275.46"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "warning"}) } }